import React from 'react';
import { Icon } from 'semantic-ui-react';

function IsValid({ isValid }: { isValid: string | boolean }) {
  if (isValid === 'Y' || isValid === 'true') {
    return <Icon name="check" color="green" size="large" />;
  }
  if (isValid === 'N' || isValid === 'false') {
    return <Icon name="close" color="red" size="large" />;
  }
  return null;
}

export default IsValid;
